import moment from "moment";
import swal from "sweetalert";

export const getDate = (date, format) => {
  if (date && date !== "N/A") {
    try {
      let newDate = new Date(date).toISOString();
      let forMattedDate = moment(newDate).format(format);
      if (forMattedDate !== "Invalid date") {
        return forMattedDate;
      } else {
        return "";
      }
    } catch (e) {}
  }
};

export const selectValueGetter = (opts, val) => {
    // if (opts.find((item) => item.value === val)) return "";
    return opts?.find((item) => item.value === val || item.value?.toUpperCase().replace(/_/g, "") === val);
};

export const alertModal = (position, icon, title, button, buttonText, timer, text) => {
    return swal({
        position,
        icon,
        title,
        [button]: buttonText,
        timer,
        text,
    });

};


export  const formatPoints = (points) => {
    const formatNumber = (num) => {
      return Number.isInteger(num) ? num : num.toFixed(2);
    };

    if (points >= 10000000) {
      return `${formatNumber(points / 10000000)}Cr`;
    } else if (points >= 100000) {
      return `${formatNumber(points / 100000)}L`;
    } else if (points >= 1000) {
      return `${formatNumber(points / 1000)}K`;
    }
    return points?.toString();
  };

  export  const formatPointData = (points) => {
    const formatNumber = (num) => {
      return Number.isInteger(num) ? num : num.toFixed(1);
    };

    if (points >= 10000000) {
      return `${formatNumber(points / 10000000)} Cr`;
    } else if (points >= 100000) {
      return `${formatNumber(points / 100000)} L`;
    } else if (points >= 1000) {
      return `${formatNumber(points / 1000)} K`;
    }
    return points?.toString();
  };

